import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/cart-reminders")({
  component: lazyRouteComponent(() => import("./-pages/admin.cart-reminders")),
  head: () => ({
    meta: [
      { title: "Cart Reminder Logs · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
